import React from 'react';
import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { jsx as _jsx } from "react/jsx-runtime";
export const YouthProtectionSign = ({
  youthProtectionColor
}) => {
  switch (youthProtectionColor) {
    case 'RED':
      return /*#__PURE__*/_jsx(YouthProtectionRed, {});
    case 'YELLOW':
      return /*#__PURE__*/_jsx(YouthProtectionYellow, {});
    default:
      return null;
  }
};
const YouthProtectionRed = styled.div.withConfig({
  displayName: "YouthProtectionSign__YouthProtectionRed",
  componentId: "sc-1as2hbt-0"
})(["background-color:", ";width:4px;height:100%;"], Colors.RED_af001e);
const YouthProtectionYellow = styled.div.withConfig({
  displayName: "YouthProtectionSign__YouthProtectionYellow",
  componentId: "sc-1as2hbt-1"
})(["border:solid 6px ", ";background-color:", ";width:24px;height:24px;"], Colors.YELLOW_eba60d, Colors.WHITE);